import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class SizeAllDocsService {

  totalSize: number = 0;

  constructor() {

   }


   countSizeDocs(value) {
    this.totalSize = this.totalSize + value;
   }

   restSizeDocs(value) {
    this.totalSize = this.totalSize - value;
   }

}
